var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14389",
    "data-name": "Group 14389",
    transform: "translate(-970 -298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    transform: "translate(970 298)",
    fill: "none",
    stroke: "#22d608",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 42.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18064",
    "data-name": "Path 18064",
    d: "M6902.523,7033.492l16.227,16.227,31.525-31.525",
    transform: "translate(-5910.023 -6688.956)",
    fill: "none",
    stroke: "#22d608",
    strokeWidth: 7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPayment);
export default __webpack_public_path__ + "static/media/success-payment.c849ce90368376ef5c5a876f25b9e70a.svg";
export { ForwardRef as ReactComponent };